var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export function getGalleryMenuProps(galleryMenuData) {
    var _a, _b, _c, _d;
    var label = galleryMenuData.fields.label;
    var column1Props = {
        eyebrow: ((_a = galleryMenuData.fields.column1) === null || _a === void 0 ? void 0 : _a.fields.eyebrow) || '',
        links: (_b = galleryMenuData.fields.column1) === null || _b === void 0 ? void 0 : _b.fields.links.map(function (galleryLink) {
            var _a, _b, _c, _d, _e, _f, _g;
            return {
                id: galleryLink === null || galleryLink === void 0 ? void 0 : galleryLink.sys.id,
                description: galleryLink === null || galleryLink === void 0 ? void 0 : galleryLink.fields.description,
                image: (_b = (_a = galleryLink === null || galleryLink === void 0 ? void 0 : galleryLink.fields) === null || _a === void 0 ? void 0 : _a.image) === null || _b === void 0 ? void 0 : _b.fields,
                mobileNavIcon: (_c = galleryLink === null || galleryLink === void 0 ? void 0 : galleryLink.fields) === null || _c === void 0 ? void 0 : _c.mobileNavIcon,
                link: __assign({ id: (_e = (_d = galleryLink === null || galleryLink === void 0 ? void 0 : galleryLink.fields) === null || _d === void 0 ? void 0 : _d.link) === null || _e === void 0 ? void 0 : _e.sys.id }, (_g = (_f = galleryLink === null || galleryLink === void 0 ? void 0 : galleryLink.fields) === null || _f === void 0 ? void 0 : _f.link) === null || _g === void 0 ? void 0 : _g.fields)
            };
        })
    };
    var column2Props = {
        eyebrow: ((_c = galleryMenuData.fields.column2) === null || _c === void 0 ? void 0 : _c.fields.eyebrow) || '',
        links: (_d = galleryMenuData.fields.column2) === null || _d === void 0 ? void 0 : _d.fields.links.map(function (galleryLink) {
            var _a, _b, _c, _d, _e, _f, _g;
            return {
                id: galleryLink === null || galleryLink === void 0 ? void 0 : galleryLink.sys.id,
                description: galleryLink === null || galleryLink === void 0 ? void 0 : galleryLink.fields.description,
                image: (_b = (_a = galleryLink === null || galleryLink === void 0 ? void 0 : galleryLink.fields) === null || _a === void 0 ? void 0 : _a.image) === null || _b === void 0 ? void 0 : _b.fields,
                mobileNavIcon: (_c = galleryLink === null || galleryLink === void 0 ? void 0 : galleryLink.fields) === null || _c === void 0 ? void 0 : _c.mobileNavIcon,
                link: __assign({ id: (_e = (_d = galleryLink === null || galleryLink === void 0 ? void 0 : galleryLink.fields) === null || _d === void 0 ? void 0 : _d.link) === null || _e === void 0 ? void 0 : _e.sys.id }, (_g = (_f = galleryLink === null || galleryLink === void 0 ? void 0 : galleryLink.fields) === null || _f === void 0 ? void 0 : _f.link) === null || _g === void 0 ? void 0 : _g.fields)
            };
        })
    };
    return { label: label, column1Props: column1Props, column2Props: column2Props };
}
